import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from "react";
import styles from "./splitContainer.module.scss";
import { SplitContext, SplitDirection } from "./splitContext";
/**
 * Creates a splitter component
 * @param props defines the splitter properties
 * @returns the splitter component
 */
export const Splitter = (props) => {
    const elementRef = props.refObject || useRef(null);
    const splitContext = useContext(SplitContext);
    let isCaptured = false;
    let startValue;
    useEffect(() => {
        if (!elementRef.current) {
            return;
        }
        if (!elementRef.current.style.width) {
            if (splitContext.direction === SplitDirection.Horizontal) {
                elementRef.current.style.width = `${props.size}px`;
                elementRef.current.style.height = `100%`;
                elementRef.current.classList.add(styles["horizontal"]);
            }
            else {
                elementRef.current.style.height = `${props.size}px`;
                elementRef.current.style.width = `100%`;
                elementRef.current.classList.add(styles["vertical"]);
            }
        }
        splitContext.sync(elementRef.current, props.controlledSide, props.initialSize, props.minSize, props.maxSize);
    });
    const onPointerDown = (evt) => {
        if (!elementRef.current) {
            return;
        }
        elementRef.current.setPointerCapture(evt.pointerId);
        isCaptured = true;
        splitContext.beginDrag();
        if (splitContext.direction === SplitDirection.Horizontal) {
            startValue = evt.clientX;
        }
        else {
            startValue = evt.clientY;
        }
        evt.preventDefault();
    };
    const onPointerMove = (evt) => {
        if (!elementRef.current || !isCaptured) {
            return;
        }
        if (splitContext.direction === SplitDirection.Horizontal) {
            splitContext.drag(evt.clientX - startValue, elementRef.current, props.controlledSide);
        }
        else {
            splitContext.drag(evt.clientY - startValue, elementRef.current, props.controlledSide);
        }
        evt.preventDefault();
    };
    const onPointerUp = (evt) => {
        if (!elementRef.current) {
            return;
        }
        elementRef.current.releasePointerCapture(evt.pointerId);
        isCaptured = false;
        splitContext.endDrag();
        evt.preventDefault();
    };
    return (_jsx("div", { id: props.id, className: styles["splitter"], ref: elementRef, onPointerDown: (evt) => onPointerDown(evt), onPointerUp: (evt) => onPointerUp(evt), onPointerMove: (evt) => onPointerMove(evt) }));
};
//# sourceMappingURL=splitter.js.map